<!-- =====================================================================
     MENU DE AÇÕES DA LINHA — um só, usado pelo desktop e pelo mobile
     =====================================================================
     Os mesmos itens do card do board, na mesma ordem: a Lista é outra visão dos mesmos
     documentos, não outro conjunto de ações. Como o clique na linha não abre o registro (a
     linha seleciona), "Editar registro" é o caminho da Lista até o documento. -->
<mat-menu #menuAcoes="matMenu">
    <ng-template matMenuContent let-linha="linha">
        <button type="button" mat-menu-item (click)="abrir.emit(linha.documento)">
            <mat-icon class="material-symbols-outlined">edit</mat-icon>
            <span>Editar registro</span>
        </button>

        <button type="button" mat-menu-item [disabled]="!podeInserir" (click)="clonar.emit(linha.documento)">
            <mat-icon class="material-symbols-outlined">content_copy</mat-icon>
            <span>{{ rotuloClonar(linha) }}</span>
        </button>

        @if (!ehPedido(linha)) {
            <button type="button" mat-menu-item [disabled]="!podeCriarModelo(linha)"
                (click)="criarModelo.emit(linha.documento)">
                <mat-icon class="material-symbols-outlined">content_copy</mat-icon>
                <span>Criar modelo</span>
            </button>
        }

        <button type="button" mat-menu-item (click)="verHistorico.emit(linha.documento)">
            <mat-icon class="material-symbols-outlined">history</mat-icon>
            <span>Ver histórico</span>
        </button>

        <!-- Financeiro (T05/T08): os mesmos itens do card, só no pedido. -->
        @if (ehPedido(linha) && !linha.documento.isFinanceiroLancado && !linha.documento.isEtapaFinalizada) {
            <span [matTooltip]="'Você não tem permissão para lançar o financeiro.'" [matTooltipDisabled]="podeLancarFinanceiro" matTooltipPosition="left">
                <button type="button" mat-menu-item [disabled]="!podeLancarFinanceiro" (click)="lancarFinanceiro.emit(linha.documento)">
                    <mat-icon class="material-symbols-outlined">payments</mat-icon>
                    <span>Lançar financeiro</span>
                </button>
            </span>
        }
        @if (ehPedido(linha) && linha.documento.isFinanceiroLancado) {
            <span [matTooltip]="'Você não tem permissão para excluir o financeiro.'" [matTooltipDisabled]="podeExcluirFinanceiro" matTooltipPosition="left">
                <button type="button" mat-menu-item [disabled]="!podeExcluirFinanceiro" (click)="excluirFinanceiro.emit(linha.documento)">
                    <mat-icon class="material-symbols-outlined">money_off</mat-icon>
                    <span>Excluir financeiro</span>
                </button>
            </span>
        }
        <!-- Estoque (T10/T11): só no pedido. Lançar some quando já lançado; Excluir, quando não há. -->
        @if (ehPedido(linha) && !linha.documento.isEstoqueLancado && !linha.documento.isEtapaFinalizada) {
            <span [matTooltip]="'Você não tem permissão para lançar o estoque.'" [matTooltipDisabled]="podeLancarEstoque"
                matTooltipPosition="left">
                <button type="button" mat-menu-item [disabled]="!podeLancarEstoque" (click)="lancarEstoque.emit(linha.documento)">
                    <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
                    <span>Lançar estoque</span>
                </button>
            </span>
        }
        @if (ehPedido(linha) && linha.documento.isEstoqueLancado) {
            <span [matTooltip]="'Você não tem permissão para excluir o estoque.'" [matTooltipDisabled]="podeExcluirEstoque"
                matTooltipPosition="left">
                <button type="button" mat-menu-item [disabled]="!podeExcluirEstoque" (click)="excluirEstoque.emit(linha.documento)">
                    <mat-icon class="material-symbols-outlined">undo</mat-icon>
                    <span>Excluir estoque</span>
                </button>
            </span>
        }

        <button type="button" mat-menu-item [disabled]="!podeExcluir" (click)="excluir.emit(linha.documento)">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
            <span>Excluir</span>
        </button>

        <!-- Grupo da oportunidade (D3, RX-01 a RX-06), com as mesmas regras do card do board. -->
        @let acoes = acoesOportunidade(linha.documento);
        <mat-divider></mat-divider>
        @if (!ehModelo(linha.documento)) {
            @if (linha.documento.idOportunidade != null) {
                @if (linha.documento.isOportunidadeForaDoEscopo) {
                    <span [matTooltip]="tooltipOportunidadeOutroVendedor" matTooltipPosition="left">
                        <button type="button" mat-menu-item disabled [attr.aria-label]="tooltipOportunidadeOutroVendedor">
                            <mat-icon class="material-symbols-outlined">lock</mat-icon>
                            <span>Oportunidade de outro vendedor</span>
                        </button>
                    </span>
                } @else {
                    <span [matTooltip]="acoes.motivoVer" matTooltipPosition="left">
                        <button type="button" mat-menu-item [disabled]="!!acoes.motivoVer"
                            [attr.aria-label]="acoes.motivoVer || null" (click)="verOportunidade.emit(linha.documento)">
                            <mat-icon class="material-symbols-outlined">handshake</mat-icon>
                            <span>{{ acoes.rotuloVer }}</span>
                        </button>
                    </span>
                    <span [matTooltip]="acoes.motivoDesvincular" matTooltipPosition="left">
                        <button type="button" mat-menu-item [disabled]="!!acoes.motivoDesvincular"
                            [attr.aria-label]="acoes.motivoDesvincular || null"
                            (click)="desvincularOportunidade.emit(linha.documento)">
                            <mat-icon class="material-symbols-outlined">link_off</mat-icon>
                            <span>Desvincular da oportunidade</span>
                        </button>
                    </span>
                }
            } @else {
                <span [matTooltip]="acoes.motivoCriar" matTooltipPosition="left">
                    <button type="button" mat-menu-item [disabled]="!!acoes.motivoCriar"
                        [attr.aria-label]="acoes.motivoCriar || null" (click)="criarOportunidade.emit(linha.documento)">
                        <mat-icon class="material-symbols-outlined">add_comment</mat-icon>
                        <span>Criar oportunidade</span>
                    </button>
                </span>
                <span [matTooltip]="acoes.motivoVincular" matTooltipPosition="left">
                    <button type="button" mat-menu-item [disabled]="!!acoes.motivoVincular"
                        [attr.aria-label]="acoes.motivoVincular || null" (click)="vincularOportunidade.emit(linha.documento)">
                        <mat-icon class="material-symbols-outlined">add_link</mat-icon>
                        <span>Vincular a oportunidade</span>
                    </button>
                </span>
            }
        }

        <span [matTooltip]="acoes.motivoVerDoCliente" matTooltipPosition="left">
            <button type="button" mat-menu-item [disabled]="!!acoes.motivoVerDoCliente"
                [attr.aria-label]="acoes.motivoVerDoCliente || null" (click)="verOportunidadesCliente.emit(linha.documento)">
                <mat-icon class="material-symbols-outlined">forum</mat-icon>
                <span>Ver oportunidades do cliente</span>
            </button>
        </span>
    </ng-template>
</mat-menu>

<!-- ================= DESKTOP ================= -->
<div class="table-container desktop-view">
    <table mat-table [dataSource]="_dataSource" matSort>
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    (change)="$event ? alternarTodos.emit() : null"
                    [checked]="listSelection.hasValue() && isTodosSelecionados()"
                    [indeterminate]="listSelection.hasValue() && !isTodosSelecionados()"
                    color="primary">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? listSelection.toggle(row) : null"
                    [checked]="listSelection.isSelected(row)"
                    color="primary">
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="numero">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
            <td mat-cell *matCellDef="let row" class="pv-numero">{{ numeroExibido(row.documento) }}</td>
        </ng-container>

        <ng-container matColumnDef="cliente">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Cliente</th>
            <td mat-cell *matCellDef="let row">
                <span class="d-block">{{ row.documento.nomePessoaCliente ?? 'Cliente não informado' }}</span>
                <small class="d-block text-muted">{{ resumoItens(row.documento.qtdItens) }}</small>
            </td>
        </ng-container>

        <ng-container matColumnDef="processo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Processo</th>
            <td mat-cell *matCellDef="let row">
                <span class="status-badge badge-cinza">
                    <mat-icon class="material-symbols-outlined">{{ row.nomeIconeProcesso }}</mat-icon>
                    {{ row.nomeProcesso }}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="etapa">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Etapa atual</th>
            <td mat-cell *matCellDef="let row">
                <span class="status-badge" [style.background]="row.corEtapa.fundo" [style.color]="row.corEtapa.conteudo">
                    <mat-icon class="material-symbols-outlined">{{ row.nomeIconeEtapa }}</mat-icon>
                    {{ row.nomeEtapa }}
                </span>
                @if (row.percentualFaixa != null) {
                    <span class="pv-percentual" matTooltip="Progresso reportado pela rotina externa">
                        <mat-icon class="material-symbols-outlined">sync_alt</mat-icon>
                        {{ row.percentualFaixa }}%
                    </span>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="tags">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tags</th>
            <td mat-cell *matCellDef="let row">
                <div class="tags-cell">
                    @for (tag of row.documento.tags; track tag.idTagVenda) {
                        <app-ui-tag [text]="tag.descricao" [bgColor]="tag.cor"></app-ui-tag>
                    }
                    <!-- Origem é como o documento NASCEU; integração é o que ele GEROU. Este chip
                         estava na coluna Integração por falta de coluna própria, e lia como se
                         "De orçamento" fosse um sistema integrado. Como marca do documento, o
                         lugar dele é entre as tags. O registro é o mesmo — não há documento
                         separado para abrir. -->
                    @if (row.documento.isOrigemOrcamento) {
                        <app-ui-tag
                            text="De orçamento"
                            icon="call_merge"
                            bgColor="#5F6368"
                            matTooltip="Este pedido nasceu como orçamento; o registro e o número são os mesmos">
                        </app-ui-tag>
                    }
                    <!-- RX-07: a marca da oportunidade vinculada, como no card. Sem coluna própria (D4). -->
                    @if (temMarcaOportunidade(row.documento)) {
                        <ng-container *ngTemplateOutlet="tplMarcaOportunidade; context: { $implicit: row.documento }"></ng-container>
                    }
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="integracoes">
            <th mat-header-cell *matHeaderCellDef class="text-center">Integrações</th>
            <td mat-cell *matCellDef="let row" class="text-center">
                @if (integracoes(row.documento).length) {
                    <span class="indicador-grid">
                        @for (integracao of integracoes(row.documento); track integracao.sigla) {
                            @if (integracao.isFinanceiro) {
                                <button type="button" class="indicador indicador-sm indicador-clicavel"
                                    [style.--indicador-cor]="integracao.cor" [matTooltip]="integracao.rotulo"
                                    [attr.aria-label]="integracao.rotulo"
                                    (click)="$event.stopPropagation(); verFinanceiro.emit(row.documento)">{{ integracao.sigla }}</button>
                            } @else {
                                <span
                                    class="indicador indicador-sm"
                                    [style.--indicador-cor]="integracao.cor"
                                    [matTooltip]="integracao.rotulo"
                                    [attr.aria-label]="integracao.rotulo"
                                    >{{ integracao.sigla }}</span
                                >
                            }
                        }
                    </span>
                } @else {
                    <span class="text-muted">—</span>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="responsavel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Responsável</th>
            <td mat-cell *matCellDef="let row">{{ row.documento.nomeVendedor ?? '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="data">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Data</th>
            <td mat-cell *matCellDef="let row">
                @if (ehModelo(row.documento)) {
                    <span class="text-muted">—</span>
                } @else {
                    {{ row.documento.dataEmissao | date: 'dd/MM/yyyy' }}
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Valor (R$)</th>
            <td mat-cell *matCellDef="let row" class="text-end">{{ row.documento.valorTotal | abnt: 'preco' : 2 }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
            <td mat-cell *matCellDef="let row" class="text-center">
                <button mat-icon-button aria-label="Ações" matTooltip="Ações da linha"
                    [matMenuTriggerFor]="menuAcoes" [matMenuTriggerData]="{ linha: row }">
                    <mat-icon>more_horiz</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.selected-row]="listSelection.isSelected(row)"></tr>
    </table>
</div>

<!-- ================= MOBILE ================= -->
<div class="mobile-view">
    @for (row of _dataSource.data; track row.documento.idVenda) {
        <div class="card-mobile mb-3" [class.selected-card]="listSelection.isSelected(row)">
            <!-- Cabeçalho no padrão dos outros cards mobile do HUB (produto, pessoa, categoria):
                 identidade à esquerda e UM botão à direita. A etapa fica no corpo — chip e botão
                 disputando a mesma linha é o que empurrava as ações para fora da tela. -->
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-2 pv-mob-identidade">
                    <mat-checkbox
                        (change)="$event ? listSelection.toggle(row) : null"
                        [checked]="listSelection.isSelected(row)"
                        color="primary">
                    </mat-checkbox>
                    <div class="d-flex flex-column pv-mob-texto">
                        <span class="text-bold">#{{ numeroExibido(row.documento) }}</span>
                        <small>{{ row.documento.nomePessoaCliente ?? 'Cliente não informado' }}</small>
                    </div>
                </div>
                <button mat-icon-button aria-label="Ações" class="pv-mob-acoes"
                    [matMenuTriggerFor]="menuAcoes" [matMenuTriggerData]="{ linha: row }">
                    <span class="material-symbols-outlined">more_horiz</span>
                </button>
            </div>

            <div class="card-body-mobile p-3">
                @if (row.documento.tags.length || row.documento.isOrigemOrcamento || temMarcaOportunidade(row.documento)) {
                    <div class="tags-cell mb-2">
                        @for (tag of row.documento.tags; track tag.idTagVenda) {
                            <app-ui-tag [text]="tag.descricao" [bgColor]="tag.cor"></app-ui-tag>
                        }
                        @if (row.documento.isOrigemOrcamento) {
                            <app-ui-tag text="De orçamento" icon="call_merge" bgColor="#5F6368"></app-ui-tag>
                        }
                        @if (temMarcaOportunidade(row.documento)) {
                            <ng-container *ngTemplateOutlet="tplMarcaOportunidade; context: { $implicit: row.documento }"></ng-container>
                        }
                    </div>
                }

                <div class="row">
                    <div class="col-12 mb-2">
                        <small class="d-block">Etapa atual</small>
                        <span
                            class="status-badge"
                            [style.background]="row.corEtapa.fundo"
                            [style.color]="row.corEtapa.conteudo">
                            <mat-icon class="material-symbols-outlined">{{ row.nomeIconeEtapa }}</mat-icon>
                            {{ row.nomeEtapa }}
                        </span>
                        @if (row.percentualFaixa != null) {
                            <span class="pv-percentual">
                                <mat-icon class="material-symbols-outlined">sync_alt</mat-icon>
                                {{ row.percentualFaixa }}%
                            </span>
                        }
                    </div>
                    <div class="col-6 mb-2">
                        <small class="d-block">Processo</small>
                        <span>{{ row.nomeProcesso }}</span>
                    </div>
                    <div class="col-6 mb-2">
                        <small class="d-block">Data</small>
                        @if (ehModelo(row.documento)) {
                            <span class="text-muted">—</span>
                        } @else {
                            <span>{{ row.documento.dataEmissao | date: 'dd/MM/yyyy' }}</span>
                        }
                    </div>
                    <div class="col-6 mb-2">
                        <small class="d-block">Responsável</small>
                        <span>{{ row.documento.nomeVendedor ?? '—' }}</span>
                    </div>
                    <div class="col-6 mb-2">
                        <small class="d-block">Valor</small>
                        <span class="text-bold">{{ row.documento.valorTotal | abnt: 'preco' : 2 }}</span>
                    </div>
                </div>
            </div>
        </div>
    }
</div>

<!-- Paginacao no padrao das listagens do HUB: "Ver Mais" no rodape, com o spinner dentro do
     proprio botao para a tabela nao piscar a cada pagina. -->
<div class="col-12 text-center">
    <button mat-button [disabled]="isUltimaPagina || isCarregandoMais" (click)="proximaPagina.emit()">
        @if (isCarregandoMais) {
        <mat-spinner [diameter]="20"></mat-spinner>
        } @else {
        <span class="material-symbols-outlined">expand_more</span>
        Ver Mais
        }
    </button>
</div>

<!-- Marca da oportunidade vinculada: abre a ficha no CRM; fora do escopo, sem o número (RX-06). -->
<ng-template #tplMarcaOportunidade let-documento>
    <button type="button" class="status-badge badge-cinza pv-marca-oportunidade"
        [matTooltip]="tooltipMarcaOportunidade(documento)" [attr.aria-label]="tooltipMarcaOportunidade(documento)"
        (click)="verOportunidade.emit(documento)">
        <mat-icon class="material-symbols-outlined">handshake</mat-icon>
        @if (!documento.isOportunidadeForaDoEscopo) {
            #{{ documento.codigoOportunidade }}
        }
    </button>
</ng-template>
